import * as React from 'react'

interface IconProps {
  style?: React.CSSProperties
  className?: string
}

const FailedIcon: React.FC<IconProps> = ({ style, className }) => {
  return (
    <svg
      className={className}
      style={style}
      version='1.2'
      baseProfile='tiny'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 50.6 17'
      width='50.6'
      height='17'
      overflow='visible'
    >
      <path
        fill='#FFCDC9'
        d='M46,0H4.6C2.1,0,0,1.8,0,4v9c0,2.2,2.1,4,4.6,4H46c2.5,0,4.6-1.8,4.6-4V4C50.6,1.8,48.5,0,46,0z'
      />
      <g>
        <path fill='#FF241F' d='M13.1,9.2h-2.8v2.9H8.8V5h4.7v1.2h-3.2v1.9h2.8V9.2z' />
        <path
          fill='#FF241F'
          d='M17.8,10.7h-2.6l-0.5,1.5h-1.6L15.8,5h1.4l2.7,7.2h-1.6L17.8,10.7z M15.6,9.5h1.8l-0.9-2.7L15.6,9.5z'
        />
        <path fill='#FF241F' d='M22.5,12.2H21V5h1.5V12.2z' />
        <path fill='#FF241F' d='M25.7,11h3.1v1.2h-4.6V5h1.5V11z' />
        <path fill='#FF241F' d='M34.4,9.1h-2.8V11h3.3v1.2h-4.8V5h4.8v1.2h-3.3v1.7h2.8V9.1z' />
        <path
          fill='#FF241F'
          d='M36.1,12.2V5h2.2C39,5,39.5,5.1,40,5.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8v0.3
		c0,0.7-0.1,1.3-0.4,1.8s-0.7,0.9-1.2,1.2c-0.5,0.3-1.1,0.4-1.7,0.4H36.1z M37.6,6.2V11h0.7c0.6,0,1-0.2,1.3-0.6s0.5-0.9,0.5-1.6
		V8.4c0-0.7-0.2-1.3-0.5-1.7c-0.3-0.4-0.7-0.6-1.3-0.6H37.6z'
        />
      </g>
    </svg>
  )
}

export default FailedIcon
